import React, { useCallback, useEffect, useMemo } from 'react';
import { Row, Col, Button, Form, Drawer, InputNumber, Select, Radio, Input } from 'antd';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
// import { putApi } from 'redux/sagas/putApiSaga';
import { API_STATUS, DATE_FORMAT, PAID_FOR, PAYMENT_METHOD } from 'constants/app-constants';
import { SERVER_IP } from 'assets/Config';
// import { postApi } from 'redux/sagas/postApiDataSaga';
import { resetApiStatus } from 'redux/reducers/globals/globalActions';
import { formQueryStringFromObject } from 'helpers';
import { getApi } from 'redux/sagas/getApiDataSaga';
import DatePicker from 'components/date-picker';
import { putApi } from 'redux/sagas/putApiSaga';
import { GET_EDIT_PERSONAL_TRAINING_PAYMENT } from 'redux/reducers/constants';
import { useI18n } from 'hooks/useI18n';
import PageLoader from 'components/page-loader';

const EditPersonalTrainingPayment = ({ paymentAddModal, setPaymentAddModal, refreshList, editPaymentId, handleClose, paymentFor, width = '40%' }) => {
	const [form] = Form.useForm();
	const globalRedux = useSelector((state) => state.globalRedux);
	const periods = useSelector((state) => state?.periodRedux?.periods) || [];
	const branchId = globalRedux?.selectedBranch?.id;
	const coaches = useSelector((state) => state?.coachRedux?.coaches);
	const customers = useSelector((state) => state?.customerRedux?.customers || []);
	const editPTPayment = useSelector((state) => state?.personalTrainingRedux?.editPTPayment || {});
	const [ PTID, setPTID ] = React.useState(null); 
	const paidValue = Form.useWatch('paid', form);
	const daysValue = Form.useWatch('days', form);
	const amountValue = Form.useWatch('amount', form);
	const paidOnValue = Form.useWatch('paidOn', form);
	const paymentMethodValue = Form.useWatch('paymentMethod', form);
	const dispatch = useDispatch();
	const { t } = useI18n();

	const string = useMemo(() => {
		const string = formQueryStringFromObject({
			branchId,
		});
		return string;
	}, [branchId]);

	useEffect(() => {
		// form?.resetFields();
		if (editPaymentId) {
			let url = `${SERVER_IP}api/personalTraining/payment/${editPaymentId}`;
			dispatch(getApi(GET_EDIT_PERSONAL_TRAINING_PAYMENT, url));
		}
	}, [dispatch, editPaymentId]);

	useEffect(() => {
		form.setFieldsValue({
			...(paidOnValue && { nextBillDate: moment(paidOnValue).add(daysValue, 'days') }),
		});
	}, [form, paidOnValue, daysValue]);

	const getCustomers = useCallback(() => {
		const string = formQueryStringFromObject({
			branchId,
		});
		let url = `${SERVER_IP}api/customers?${string}`;
		branchId && dispatch(getApi('GET_CUSTOMERS', url));
	}, [dispatch, branchId]);

	// useEffect(() => {
	// 	form.setFieldValue('personalTrainingImages', personalTrainingImages)
	// }, [personalTrainingImages, form])

	const getCoaches = useCallback(() => {
		let url = `${SERVER_IP}api/coaches?${string}`;
		dispatch(getApi('GET_COACHES', url));
	}, [dispatch, string]);

	const getPeriods = useCallback(() => {
		const string = formQueryStringFromObject({
			branchId: globalRedux?.selectedBranch?.id,
		});
		let url = `${SERVER_IP}api/period?${string}`;
		dispatch(getApi('GET_PERIODS', url));
	}, [dispatch, globalRedux?.selectedBranch?.id]);

	useEffect(() => {
		if(paymentAddModal) {
			getCustomers();
			getCoaches();
			getPeriods();
		}
	}, [getCustomers, getCoaches, getPeriods, paymentAddModal]);

	const handleSubmit = (values) => {
		let data = {
			amount: values?.amount || 0,
			balance: values?.balance || 0,
			branchId,
			coachId: values?.coachId,
			customerId: values?.customerId,
			days: values?.days,
			id: editPaymentId,
			nextBillDate: values?.nextBillDate,
			paid: values?.paid || 0,
			paidFor: PAID_FOR.personal_training,
			paidOn: values?.paidOn || moment(),
			paymentMethod: values?.paymentMethod,
			...(paymentMethodValue === PAYMENT_METHOD[1]?.value && { upiTransactionId: values?.upiTransactionId || '' }),
			personalTrainingId: PTID,
			receivedBy: values?.receivedBy,
			remarks: values?.remarks,
		};
		let url = `${SERVER_IP}api/personalTraining/payment/${editPaymentId}`;
		dispatch(putApi(data, 'EDIT_PERSONAL_TRAINING', url));
	};

	useEffect(() => {
		if (globalRedux.apiStatus.ADD_PERSONAL_TRAINING === 'SUCCESS' || globalRedux.apiStatus.EDIT_PERSONAL_TRAINING === 'SUCCESS') {
			dispatch(resetApiStatus(editPaymentId ? 'EDIT_PERSONAL_TRAINING' : 'ADD_PERSONAL_TRAINING'));
			refreshList?.(true);
			handleClose?.();
			form?.resetFields();
		}
	}, [globalRedux.apiStatus, editPaymentId, dispatch, refreshList, handleClose, form]);

	useEffect(() => {
		if (globalRedux.apiStatus.GET_EDIT_PERSONAL_TRAINING_PAYMENT === 'SUCCESS') {
			form?.resetFields();
			setPTID(editPTPayment?.personal_training_ma?.id);
			form?.setFieldsValue({
				...editPTPayment,
				paidOn: moment(editPTPayment?.paidOn),
				nextBillDate: moment(editPTPayment?.nextBillDate),
				customerId: editPTPayment?.personal_training_ma?.customerId,
				coachId: editPTPayment?.personal_training_ma?.coachId,
				days: editPTPayment?.personal_training_ma?.days,
				amount: editPTPayment?.personal_training_ma?.amount,
				paid: editPTPayment?.paid,
				balance: editPTPayment?.balance,
			});
		}
	}, [globalRedux.apiStatus, form, editPTPayment]);

	const layer1FormCol = {
		labelCol: {
			span: 12,
		},
		wrapperCol: {
			span: 12,
		},
	};

	const onClose = () => {
		setPaymentAddModal(false);
		handleClose?.();
		form?.resetFields();
	};

	const calculateBalance = useCallback(() => {
		const amountFormValue = form.getFieldValue('paid');
		let actualAmount = form.getFieldValue('amount');

		const balance = actualAmount - amountFormValue;

		form.setFieldValue('balance', balance);
	}, [form]);

	useEffect(() => {
		if (paidValue) {
			calculateBalance();
		}
	}, [paidValue, calculateBalance]);

	useEffect(() => {
		if (amountValue) {
			calculateBalance();
		}
	}, [amountValue, calculateBalance]);

	const loading =
		globalRedux.apiStatus.ADD_PERSONAL_TRAINING === API_STATUS.PENDING || globalRedux.apiStatus.EDIT_PERSONAL_TRAINING === API_STATUS.PENDING;
	const customerLoading = useMemo(() => globalRedux?.apiStatus.GET_CUSTOMER === API_STATUS.PENDING, [globalRedux?.apiStatus?.GET_CUSTOMER]);
	const coachLoading = useMemo(() => globalRedux?.apiStatus.GET_COACHES === API_STATUS.PENDING, [globalRedux?.apiStatus?.GET_COACHES]);
	const paymentLoading = useMemo(() => globalRedux?.apiStatus[GET_EDIT_PERSONAL_TRAINING_PAYMENT] === API_STATUS.PENDING, [globalRedux?.apiStatus]);
	
	return (
		<Drawer
			placement="right"
			title={editPaymentId ? t('forms.edit_personal_training') : t('forms.new_personal_training')}
			width={width || '40%'}
			open={paymentAddModal}
			closable
			onClose={onClose}
			destroyOnClose={true}>
			{paymentLoading && <PageLoader />}
			<Row>
				<Col span={24}>
					<Row style={{ marginTop: 20 }}>
						<Form
							name="add-personalTraining"
							className="required_in_right"
							style={{ width: '100%' }}
							colon={true}
							labelAlign="left"
							form={form}
							onFinish={handleSubmit}
							initialValues={{}}
							{...layer1FormCol}>
							<Form.Item
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}
								label={t('forms.customer_name')}
								name="customerId">
								<Select
									showSearch
									disabled
									optionFilterProp="children"
									filterOption={(input, option) => {
										return option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
									}}
									loading={customerLoading}
									placeholder={t('forms.customer_name')}>
									{(customers || [])?.map((customer) => (
										<Select.Option value={customer.id}>{`${customer?.customerName} - ${customer?.mobile}`}</Select.Option>
									))}
								</Select>
							</Form.Item>
							<Form.Item
								rules={[
									{
										required: true,
										message: t('forms.this_field_required'),
									},
								]}
								label={t('forms.trainer_name')}
								name="coachId">
								<Select
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) => {
										return option.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
									}}
									loading={coachLoading}
									placeholder={t('forms.trainer_name')}>
									{(coaches || [])?.map((coach) => (
										<Select.Option value={coach.id}>{`${coach?.coachName} - ${coach?.mobile}`}</Select.Option>
									))}
								</Select>
							</Form.Item>
							<>
								<Form.Item
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}
									label={t('forms.days')}
									name="days">
									<Select placeholder={t('forms.days')}>
										{(periods || [])?.map((period) => (
											<Select.Option value={period.days}>{`${period?.name} - ${period?.days} days`}</Select.Option>
										))}
									</Select>
								</Form.Item>
								<Form.Item
									label={t('forms.amount')}
									name="amount"
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}>
									<InputNumber disabled placeholder={t('forms.amount')} style={{ width: '100%' }} />
								</Form.Item>
								<Form.Item
									label={t('forms.paid')}
									name="paid"
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}>
									<InputNumber placeholder={t('forms.paid')} style={{ width: '100%' }} />
								</Form.Item>
								<Form.Item
									label={t('forms.balance')}
									name="balance"
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}>
									<InputNumber disabled placeholder={t('forms.balance')} style={{ width: '100%' }} />
								</Form.Item>
								<Form.Item
									label={t('forms.payment_method')}
									name="paymentMethod"
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}>
									<Radio.Group style={{ width: '100%' }} options={PAYMENT_METHOD} optionType="button" buttonStyle="solid" />
								</Form.Item>
								{paymentMethodValue === PAYMENT_METHOD[1]?.value && (
									<Form.Item
										label={t('forms.upi_transaction_id')}
										name="upiTransactionId"
										rules={[
											{
												required: true,
												message: t('forms.this_field_required'),
											},
										]}>
										<InputNumber placeholder={t('forms.upi_transaction_id')} style={{ width: '100%' }} />
									</Form.Item>
								)}
								<Form.Item
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}
									label={t('forms.received_by')}
									name="receivedBy">
									<Select loading={coachLoading} placeholder={t('forms.received_by')}>
										{coaches?.map((coach) => (
											<Select.Option value={coach.id} key={coach.id}>
												{coach?.coachName}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
								<Form.Item
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}
									label={t('forms.paid_on')}
									name="paidOn">
									<DatePicker style={{ width: '100%' }} format={DATE_FORMAT.DD_MM_YYYY} />
								</Form.Item>
								<Form.Item
									rules={[
										{
											required: true,
											message: t('forms.this_field_required'),
										},
									]}
									label={t('forms.next_bill_date')}
									name="nextBillDate">
									<DatePicker style={{ width: '100%' }} format={DATE_FORMAT.DD_MM_YYYY} />
								</Form.Item>
							</>
							<Form.Item
								label={t('forms.remarks')}
								name="remarks"
								rules={[
									{
										required: false,
										message: t('forms.this_field_required'),
									},
								]}>
								<Input.TextArea />
							</Form.Item>
							<Form.Item
								wrapperCol={{
									offset: 0,
									span: 24,
								}}>
								<Row className="space-between" style={{ paddingTop: 20, width: '100%', margin: 0 }}>
									<Button danger style={{ width: '49%' }} onClick={onClose}>
										{t('forms.cancel')}
									</Button>
									<Button loading={loading} style={{ width: '49%' }} type="primary" htmlType="submit">
										{editPaymentId ? t('forms.update') : t('forms.save')}
									</Button>
								</Row>
							</Form.Item>
						</Form>
					</Row>
				</Col>
			</Row>
		</Drawer>
	);
};

export default EditPersonalTrainingPayment;
